var map = {
	"./bingbao.png": "3443",
	"./lei.png": "2fed",
	"./qing.png": "70c0",
	"./shachen.png": "8fc5",
	"./wu.png": "6552",
	"./xue.png": "d298",
	"./yin.png": "0858",
	"./yu.png": "454e",
	"./yun.png": "1143"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "954e";